import { AsNumber, AsText } from '@adserve/adserve-react-components';
import React, { useContext } from 'react';
import { CampaignGoalEnum } from '../../../constants/Enums';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { ValidateJcn } from '../../../services/CampaignsDataService';
import { inputStyle, labelStyle, requiredPanelStyle } from '../CampaignBrief/CampaignBriefStyles';

const errorStyle = {
    borderColor: '#C40606',
    backgroundColor: '#FFF3F3'
};

const statusLabelStyle = {
    position: 'absolute',
    color: '#C40606',
    fontSize: 12
};

const CampaignBurstCommercials = ({
    campaignBurst,
    parentCampaign,
    usedBudget,
    updateCampaignBurst,
    setValidJcn,
    validJcn,
    readOnly
}) => {
    const { formatCurrency } = useContext(SystemSettingsContext);
    const { showInvalidatePlanMessage } = useContext(AirtimePlanningContext);

    const updateBurst = (event) => {
        updateCampaignBurst(event.target.name, event.target.value);
    };

    const handleBurstBudgetUpdate = (event) => {
        let { value } = event.target;

        if (value > availableBudget) {
            value = availableBudget;
        }

        updateCampaignBurst(event.target.name, value);
        showInvalidatePlanMessage(event.target);
    };

    const handleValidateJCN = async (event) => {
        const result = await ValidateJcn(event.target.value);
        setValidJcn(result);
    };

    let availableBudget = 0;
    if (usedBudget !== undefined) {
        availableBudget = (parentCampaign?.campaignGoal?.find((s) => s.goal.toLowerCase() === CampaignGoalEnum.BUDGET.toLowerCase()).value ?? 0) - usedBudget;
    }

    return (
        <div style={{ ...requiredPanelStyle, paddingBottom: 20, display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 15, fontWeight: 500, marginBottom: 10 }}>
                {window.translate('Burst Commercials')}
            </span>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '20%' }}>
                    <AsText
                        id='burst-jcn'
                        name='jcn'
                        title={window.translate('JCN Number')}
                        labelStyle={labelStyle}
                        inputStyle={{ ...inputStyle, ...(!validJcn ? errorStyle : {})}}
                        value={campaignBurst?.jcn}
                        onChange={updateBurst}
                        onBlur={handleValidateJCN}
                        disabled={readOnly}
                    />
                    {!validJcn && (
                        <label style={statusLabelStyle}>{window.translate('Invalid JCN - check digit failed')}</label>
                    )}
                </div>
                <div style={{ width: '20%', marginLeft: '2%' }}>
                    <AsNumber
                        id='total-available'
                        title={window.translate('Total available')}
                        labelStyle={labelStyle}
                        inputStyle={inputStyle}
                        value={availableBudget}
                        formatCurrency={formatCurrency}
                        disabled={true}
                    />
                </div>
                <div style={{ width: '20%' }}>
                    <AsNumber
                        id='burst-budget'
                        name='budget'
                        title={window.translate('Burst budget *')}
                        labelStyle={labelStyle}
                        inputStyle={inputStyle}
                        value={campaignBurst?.budget}
                        onChange={handleBurstBudgetUpdate}
                        formatCurrency={formatCurrency}
                        allowFloat={true}
                        disabled={readOnly}
                    />
                </div>
            </div>
        </div>
    );
};

export default CampaignBurstCommercials;
